import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import BuyYearReportForm from "@components/dynamic/BuyYearReportForm";

const BuyByYearReport = () => {
  useEffect(() => {
  }, []);


  return (
    <PageContainer
      title="Reporte de Compras por año"
      backUrl="/user/dashboard-accounting"
    >
      <BuyYearReportForm />
    </PageContainer >
  );
}

export default BuyByYearReport;
